import type { FaireProductEntity } from "../../entity_types/product";

export const p_xx5hpaakb9: FaireProductEntity = {
  token: "p_xx5hpaakb9",
  type: "product",
  name: "*NEW* Small Green Gold Rivet Basic Notepad - Stationery",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/485f2e4f067b110140b6b47fd49dc5d51635e125bc4a46324c8754915e1d97e1.png",
  priceDollars: 6,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/86db89168d4ea94f75c95f3f49342b7232271b5dc15cfe6477ec7a76b0012bad.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
